import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import _ from 'lodash';
import { SpaceType } from '@/domains/spaces/enums';
function createEmptySpaceEditableData() {
    return {
        spaceType: SpaceType.Undefined,
        spaceName: '',
        tags: [],
        buildInIconId: `${_.random(16, 24)}`,
    };
}
let EditingSpaceModelImpl = class EditingSpaceModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = createEmptySpaceEditableData();
    }
    dispose() {
        this.update(() => (createEmptySpaceEditableData()));
    }
};
EditingSpaceModelImpl = __decorate([
    injectable()
], EditingSpaceModelImpl);
export { EditingSpaceModelImpl };
